import PropTypes from "prop-types";

import { getImageProperties } from "studio-edifique/siteContent";

function ResponsiveImage({
  src,
  alt,
  sizes = "(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw",
  eager = false,
  style = {},
}) {
  const properties = getImageProperties(src);
  return (
    <img
      src={src}
      alt={alt}
      srcSet={properties.srcSet}
      width={properties.width}
      height={properties.height}
      sizes={sizes}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      style={{ display: "block", width: "100%", height: "auto", borderRadius: "0.75rem", ...style }}
    />
  );
}

ResponsiveImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sizes: PropTypes.string,
  eager: PropTypes.bool,
  style: PropTypes.object,
};

export default ResponsiveImage;
